import { MiraApiClient, type Locale, type TokenStore } from '@mira/clients-shared';

const tokenKey = 'mira.web.token';

export class WebTokenStore implements TokenStore {
  async getToken(): Promise<string | null> {
    return window.localStorage.getItem(tokenKey);
  }

  async setToken(token: string | null): Promise<void> {
    if (token) window.localStorage.setItem(tokenKey, token);
    else window.localStorage.removeItem(tokenKey);
  }
}

export function outputLocale(): Locale {
  return 'en-US';
}

export const tokenStore = new WebTokenStore();

export function hasStoredToken(): boolean {
  return Boolean(window.localStorage.getItem(tokenKey));
}

export function createWebApiClient(): MiraApiClient {
  return new MiraApiClient({
    baseUrl: import.meta.env?.VITE_MIRA_API_BASE_URL || '/api',
    channel: {
      platform: 'web',
      region: 'GLOBAL',
      inputLocale: outputLocale(),
      outputLocale: outputLocale(),
    },
    tokenStore,
  });
}
